import * as contentful from 'contentful';

const client = contentful.createClient({
    space: "cq3uu0t7a9gz",
    accessToken: "NXiqrRSBhB5GMnuTgdeaCbhUzAwuOKkdqLXGVWrizqE"
})

export default client;